var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"oncontextmenu":"return false"}},[_c(_vm.layout,{tag:"component"},[_c('router-view'),_vm._v(" "),_c('slideout-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }